import axios from "axios";
import { BASE_URL } from "../config/config";

class ClientApiModule {
  constructor() {
    this.base_url = BASE_URL;
  }

  getClientTicketById() {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${this.base_url}client/get-all-client-ticket`,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getClientByQrId(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        params: data,
        url: `${this.base_url}client/get-client-based-on-qr`,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  PublicTicketBookingWithInc(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${this.base_url}center/public-ticket-booking-withINC`,
        data: data,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getAllClientServices(qrId) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${this.base_url}admin/get-all-center-services`,
        params: { qr_id: qrId },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  clientCreateTicketDashboard(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${this.base_url}client/client-create-ticket-withQR`,
        data: data,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //   createTechnician(data) {
  //     return new Promise((resolve, reject) => {
  //       axios({
  //         method: "post",
  //         url: `${this.base_url}client/create-technician`,
  //         data: data,
  //       })
  //         .then((res) => {
  //           resolve(res.data);
  //         })
  //         .catch((err) => {
  //           reject(err);
  //         });
  //     });
  //   }

  //   publicTicketBooking(data) {
  //     return new Promise((resolve, reject) => {
  //       axios({
  //         method: "post",
  //         url: `${this.base_url}client/public-ticket-booking-withINA`,
  //         data: data,
  //       })
  //         .then((res) => {
  //           resolve(res.data);
  //         })
  //         .catch((err) => {
  //           reject(err);
  //         });
  //     });
  //   }
}

export default ClientApiModule;
